<template>
    <div class="channel-access">
        <div style="height:100%;">
            <div class="sip-content">
                <div class="tab">
                    <span @click="chooseLoginState('')" :class="{'active':currentState==''}">全部</span>
                    <span @click="chooseLoginState('LOGGED_IN')" :class="{'active':currentState=='LOGGED_IN'}">已登录</span>
                    <span @click="chooseLoginState('NOT_LOGGED_IN')" :class="{'active':currentState=='NOT_LOGGED_IN'}">未登录</span>
                    <div @click="chooseBatch">批量操作</div>
                </div>
                <div class="list-content">
                    <div class="box" v-for="(item, index) in boxList" :key="index">
                        <div class="info">
                            <div style="padding-bottom:10px;border-bottom:1px solid rgba(221, 221, 221, 1)">
                                <img src="../../assets/img/phone.png" alt="">
                                <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold;">{{item.channelCode}}</span>
                                <span @click="loginOut(item.channelCode)" v-if="item.status=='LOGGED_IN'" style="font-size:13px;float:right;color:rgba(34, 215, 187, 1);cursor:pointer;margin-top:4px;">退出</span>
                                <span @click="loginIn(item.channelCode)" v-if="item.status=='NOT_LOGGED_IN'" style="font-size:13px;float:right;color:rgba(255, 195, 0, 1);cursor:pointer;margin-top:4px;">登录</span>
                                <span @click="loginIn(item.channelCode)" v-if="item.status=='DISCONNECT'" style="font-size:13px;float:right;color:rgba(255, 34, 34, 1);cursor:pointer;margin-top:4px;">重连</span>
                                <span @click="loginIn(item.channelCode)" v-if="item.status=='FAIL'" style="font-size:13px;float:right;color:rgba(172, 52, 196, 1);cursor:pointer;margin-top:4px;">重连</span>
                                <span @click="loginOut(item.channelCode)" v-if="item.status=='LOGGING_IN'" style="font-size:13px;float:right;color:rgba(44, 132, 228, 1);cursor:pointer;margin-top:4px;">取消</span>
                            </div>
                            <div style="padding-top:8px;">
                                <a-icon v-if="item.status=='LOGGED_IN'" style="font-size:13px;color:rgba(34, 215, 187, 1);float:left;margin-top:4px;" type="link" />
                                <a-icon v-if="item.status=='LOGGING_IN'" style="font-size:13px;color:rgba(44, 132, 228, 1);float:left;margin-top:4px;" type="loading" />
                                <a-icon v-if="item.status=='NOT_LOGGED_IN'" style="font-size:13px;color:rgba(255, 195, 0, 1);float:left;margin-top:4px;" type="wifi" />
                                <a-icon v-if="item.status=='DISCONNECT'" style="font-size:13px;color:rgba(255, 34, 34, 1);float:left;margin-top:4px;" type="disconnect" />
                                <a-icon v-if="item.status=='FAIL'" style="font-size:13px;color:rgba(172, 52, 196, 1);float:left;margin-top:4px;" type="exclamation-circle" />
                                <span v-if="item.status=='LOGGED_IN'" style="font-size:12px;margin-left:4px;color:rgba(34, 215, 187, 1)">已登录</span>
                                <span v-if="item.status=='LOGGING_IN'" style="font-size:12px;margin-left:4px;color:rgba(44, 132, 228, 1)">登录中</span>
                                <span v-if="item.status=='NOT_LOGGED_IN'" style="font-size:12px;margin-left:4px;color:rgba(255, 195, 0, 1)">未登录</span>
                                <span v-if="item.status=='DISCONNECT'" style="font-size:12px;margin-left:4px;color:rgba(255, 34, 34, 1)">掉线</span>
                                <span v-if="item.status=='FAIL'" style="font-size:12px;margin-left:4px;color:rgba(172, 52, 196, 1)">登录失败</span>
                                <span v-if="item.status!='NOT_LOGGED_IN'" class="info-content">{{item.sipCode}}
                                    <div class="new-box">
                                        <div class="in-new-box">
                                            <div class="box-mask"></div>
                                            <div style="position:absolute;left:0px;top:0px;padding:16px 8px 16px 16px;">
                                                <div class="information">
                                                    <span>通道号：</span>
                                                    <span>{{item.channelCode}}</span>
                                                </div>
                                                <div class="information">
                                                    <span>注册地址：</span>
                                                    <span>{{item.url}}</span>
                                                </div>
                                                <div class="information">
                                                    <span>端口：</span>
                                                    <span>{{item.port}}</span>
                                                </div>
                                                <div class="information">
                                                    <span>分机号：</span>
                                                    <span>{{item.sipCode}}</span>
                                                </div>
                                                <div class="information">
                                                    <span>密码：</span>
                                                    <span>{{item.password}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>

                    </div>
                    <div style="text-align:center;" v-if="boxList.length==0">
                        <img style="width:140px;margin:200px auto;" src="../../assets/img/none.png" alt="">
                    </div>
                </div>
            </div>
            <div class="tutorials" style="">
                <div style="height:100%;background:#fff;">
                    <div style="width:160px;height:100%;color:rgba(80, 80, 80, 1);font-size:16px;font-weight:bold;padding-top:33px;padding-left:24px;display:inline-block;float:left">可接入渠道品牌</div>
                    <div class="brand-box" :style="{width: screenWidth + 'px'}">
                        <a-carousel arrows :dots='false' :autoplay='true'>
                            <!-- <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;zIndex: 1" >
                                <a-icon type="left-circle" />
                            </div>
                            <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                                <a-icon type="right-circle" />
                            </div> -->
                            <div class="carousel-pic" style="float:left;" v-for="(item, index) in picData" :key="index">
                                <div @click="jumpToLink(item1.url)" style="cursor:pointer" class="con" v-for="(item1, index1) in item" :key="index1">
                                    <img :src="item1.picture" alt="">
                                    <div style="color:rgba(80, 80, 80, 1);font-size:12px;text-align:center;">{{item1.name}}</div>
                                </div>
                            </div>
                        </a-carousel>
                    </div>
                </div>
            </div>
        </div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="pathLogin" title="通道登录" footer='' width='440px'>
            <div class="path-modal" style="height:242px;">
                <div v-if="accoutBool" class="accout">
                    <div class="item">
                        <span>通道号：</span>
                        <a-input :placeholder="loginData.channelCode" :disabled='true'/>
                    </div>
                    <div class="item">
                        <span>注册地址：</span>
                        <a-input placeholder="请输入注册地址" v-model.trim="loginData.url"/>
                    </div>
                    <div class="item">
                        <span>端口：</span>
                        <a-input placeholder="请输入端口号" v-model.trim="loginData.port"/>
                    </div>
                    <div class="item">
                        <span>分机号：</span>
                        <a-input placeholder="请输入分机号" v-model.trim="loginData.sipCode"/>
                    </div>
                    <div class="item">
                        <span>密码：</span>
                        <a-input placeholder="请输入密码" v-model.trim="loginData.password"/>
                    </div>
                    <div class="btn-group">
                        <span @click="cancelPath">取消</span>
                        <span @click="sipLogin">确认</span>
                    </div>
                </div>
                <div v-if="loadingBool" class="loading">
                    <div style="padding-top:35px;">
                        <a-icon type="loading" />
                    </div>
                    <div style="padding-top:32px;">正在连接，请稍后</div>
                </div>
                <div v-if="successBool" class="judge">
                    <div style="padding:36px 0 30px 0">
                        <img src="../../assets/img/right.jpg" alt="">
                    </div>
                    <p>登录成功</p>
                </div>
                <div v-if="errorBool" class="judge">
                    <div style="padding:36px 0 30px 0">
                        <img src="../../assets/img/wrong.jpg" alt="">
                    </div>
                    <p>登录失败</p>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="pathPayment" title="退出登录" footer='' width='440px'>
            <div class="path-modal" style="height:124px;">
                <div class="path-activation">
                    <div class="twice-sure">
                        <a-icon type="question-circle" />
                        <span>您确认要退出登录吗？</span>
                    </div>
                    <div class="title">退出后，连接将断开</div>
                    <div class="btn-group">
                        <span @click="cancelPayment">取消</span>
                        <span @click="surePayment">确认</span>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="batchLogin" :title="loginTitle" footer='' width='880px'>
            <div class="choose-path" v-if="ifShowChoosePath">
                <div class="modal-choose-state">
                    <span @click="clickLoginState('unlogin')" :class="{'active':currentChooseState=='unlogin'}">未登录</span>
                    <span @click="clickLoginState('loginFail')" :class="{'active':currentChooseState=='loginFail'}">登录失败</span>
                    <span @click="clickLoginState('loginOffline')" :class="{'active':currentChooseState=='loginOffline'}">掉线</span>
                </div>
                <div style="min-height:300px;max-height:450px;overflow-y:auto;padding-top:16px;">
                    <div v-if="currentChooseState=='unlogin'">
                        <div style="padding-bottom:16px;">
                            <a-input-search placeholder="请输入搜索内容" @change='changeInput1' style="width: 200px" />
                            <a-checkbox v-if="unLoginData2.length>0" :checked='ifUnloginChecked' style="float:right" @change="unloginCheckall">
                                全选
                            </a-checkbox>
                        </div>
                        <a-checkbox-group class="checkbox-list" v-if="unLoginData2.length>0" v-model.trim="selectedUnloginData" :options="unLoginData2" @change="changeUnloginData" style="width:100%;padding-left:0px;">
                        </a-checkbox-group>
                        <img v-if="unLoginData2.length==0" style="width:140px;margin:50px auto 0;display:block;"  src="../../assets/img/none.png" alt="">
                    </div>
                    <div v-if="currentChooseState=='loginFail'">
                        <div style="padding-bottom:16px;">
                            <a-input-search placeholder="请输入搜索内容" @change='changeInput2' style="width: 200px" />
                            <a-checkbox v-if="loginFailedData2.length>0" :checked='ifLoginFailedChecked' style="float:right" @change="loginFailedCheckall">
                                全选
                            </a-checkbox>
                        </div>
                        <a-checkbox-group class="checkbox-list" v-if="loginFailedData2.length>0" v-model.trim="selectedLoginFailedData" :options="loginFailedData2" @change="changeLoginFailedData" style="width:100%;padding-left:0px">
                        </a-checkbox-group>
                        <img v-if="loginFailedData2.length==0" style="width:140px;margin:50px auto 0;display:block;"  src="../../assets/img/none.png" alt="">
                    </div>
                    <div v-if="currentChooseState=='loginOffline'">
                        <div style="padding-bottom:16px;">
                            <a-input-search placeholder="请输入搜索内容" @change='changeInput3' style="width: 200px" />
                            <a-checkbox v-if="loginOfflineedData2.length>0" :checked='ifOfflineedChecked' style="float:right" @change="loginOfflinedCheckall">
                                全选
                            </a-checkbox>
                        </div>
                        
                        <a-checkbox-group class="checkbox-list" v-if="loginOfflineedData2.length>0" v-model.trim="selectedOfflineedData" :options="loginOfflineedData2" @change="changeOfflineedData" style="width:100%;padding-left:0px;">
                        </a-checkbox-group>
                        <img v-if="loginOfflineedData2.length==0" style="width:140px;margin:50px auto 0;display:block;"  src="../../assets/img/none.png" alt="">
                    </div>
                </div>
                <div class="operate-btn">
                    <span @click="offShowPath">取消</span>
                    <span @click="nextStep">下一步</span>
                </div>
            </div>
            <div class="batch-login" v-if="ifShowBatchLogin">
                <div class="modal-site">
                    <a-row>
                        <a-col :span="12">
                            <span class="title">注册地址：</span>
                            <a-input v-model.trim="registerSite" placeholder="请输入账号" />
                        </a-col>
                        <a-col :span="12">
                            <span class="title">端口：</span>
                            <a-input v-model.trim="registerPort" placeholder="请输入IP地址" />
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="12">
                            <span v-if="siteTip" class="tip">*注册地址为必填项，输入后才能提交</span>
                        </a-col>
                        <a-col :span="12">
                            <span v-if="portTip" class="tip">*端口为必填项，输入后才能提交</span>
                        </a-col>
                    </a-row>
                </div>
                <a-row style="padding-bottom:12px;color:rgba(51, 51, 51, 1);font-size:14px;padding-top:12px;">
                    <a-col :span="4">
                        <div>通道号</div>
                    </a-col>
                    <a-col :span="10">
                        <div>分机号</div>
                    </a-col>
                    <a-col :span="10">
                        <div>
                            <span>密码</span>
                            <div style="display:inline-block;float:right">
                                <a-checkbox :checked="ifSame" @change="keepSamePassword"></a-checkbox>
                                <span>密码一致</span>
                            </div>
                        </div>
                    </a-col>
                </a-row>
                <div style="min-height:230px;max-height:419px;overflow-y:auto;">
                    <a-row v-for="(item, index) in totalSelectedData" :key="index" style="padding-bottom:12px;color:rgba(51, 51, 51, 1);font-size:14px;">
                        <a-col :span="4">
                            <div style="float:left;margin-top:4px;">{{item.channelCode}}</div>
                        </a-col>
                        <a-col :span="10">
                            <a-input v-model.trim="item.extensionCode" style="width:70%" placeholder="请输入分机号" />
                            <span v-if="item.boolTip" style="color:rgba(212, 48, 48, 1);font-size:12px;">*分机号不能一致</span>
                        </a-col>
                        <a-col :span="10">
                            <div>
                                <a-input :disabled='item.disabled' v-model.trim="item.password" style="width:90%" :placeholder="item.placeholdcontent" />
                                <a-icon @click="deleteItem(index)" title="删除" style="color:rgba(212, 48, 48, 1);font-size:14px;margin-left:6px;cursor:pointer;" type="close" />
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="operate-btn">
                    <span @click="offShowPath">取消</span>
                    <span @click="sureSubmit">确认</span>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="batchOperation" title="批量操作选择" footer='' width='440px'>
            <div class="batch-operation">
                <div class="title">选择您要进行的操作：</div>
                <div @click="chooseOperateWay(true)" class="select-box" :class="{'active':chooseLoginIn}">
                    <div class="box-title">批量登录</div>
                    <div class="box-content">您可以对有相同注册地址和端口的通道号进行批量登录，输入对应的分机号和密码，若密码一致可一键填充</div>
                </div>
                <div @click="chooseOperateWay(false)" class="select-box" :class="{'active':!chooseLoginIn}">
                    <div class="box-title">批量登出</div>
                    <div class="box-content">您可对任意已登录的通道号进行批量登出，可在搜索框中输入通道号的前几位进行查询，快速锁定执行对象</div>
                </div>
                <div class="operate-btn">
                    <span @click="offOperation">取消</span>
                    <span @click="nextOperation">下一步</span>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="batchLoginOut" title="批量登出" footer='' width='880px'>
            <div class="batch-loginout">
                <div style="padding-bottom:16px;">
                    <a-input-search placeholder="请输入搜索内容" @change='changeInput4' style="width: 200px" />
                    <a-checkbox v-if="hasLoginData2.length>0" :checked='ifHasLoginedChecked' style="float:right" @change="hasLoginedCheckall">
                        全选
                    </a-checkbox>
                </div>
                <a-checkbox-group class="checkbox-list" v-if="hasLoginData2.length>0" v-model.trim="selectedLoginedOutData" :options="hasLoginData2" @change="changeLoginedData" style="width:100%;padding-left:0px;">
                </a-checkbox-group>
                <img v-if="hasLoginData2.length==0" style="width:140px;margin:50px auto 0;display:block;"  src="../../assets/img/none.png" alt="">
                <div class="operate-btn">
                    <span @click="offBatchLoginOut">取消</span>
                    <span @click="sureBatchLoginOut">确定</span>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    name: 'ChannelAccess',
    props: {
        msg: String
    },
    data() {
        return {
            boxList: [],
            currentState: "",
            pathLogin: false,
            accoutBool: true,
            loadingBool: false,
            successBool: false,
            errorBool: false,
            pathPayment: false,
            emptyContent: false,
            loginData: {
                channelCode: '',
                url: '',
                port: '',
                sipCode: '',
                password: ''
            },
            channelCode: '',
            timer: '',
            batchLogin: false,
            loginTitle: '选择通道',
            ifShowChoosePath: true,
            ifShowBatchLogin: false,
            currentChooseState: 'unlogin',
            siteTip: false,
            portTip: false,
            unLoginData1: [],//请求值
            unLoginData2: [],//显示值
            loginFailedData1: [],
            loginFailedData2: [],
            loginOfflineedData1: [],
            loginOfflineedData2: [],
            selectedUnloginData: [],
            selectedLoginFailedData: [],
            selectedOfflineedData: [],
            totalSelectedList: [],
            totalSelectedData: [],
            registerSite: '',
            registerPort: '',
            ifSame: false,
            ifUnloginChecked: false,
            ifLoginFailedChecked: false,
            ifOfflineedChecked: false,
            picList: [],
            picData: [],
            screenWidth: 0,
            batchOperation: false,
            chooseLoginIn: true,
            batchLoginOut: false,
            hasLoginData1: [],
            hasLoginData2: [],
            ifHasLoginedChecked: false,
            selectedLoginedOutData: []
        };
    },
    methods: {
        changeLoginedData(e) {
            this.selectedLoginedOutData = e
            if(this.selectedLoginedOutData.length == this.hasLoginData2.length){
                this.ifHasLoginedChecked = true
            }else{
                this.ifHasLoginedChecked = false
            }
        },
        hasLoginedCheckall(e) {
            this.ifHasLoginedChecked = e.target.checked
            if(e.target.checked) {
                this.selectedLoginedOutData = []
                for(let i = 0; i < this.hasLoginData2.length; i++){
                    this.selectedLoginedOutData.push(this.hasLoginData2[i]['value'])
                }
            }else{
                this.selectedLoginedOutData = []
            }
        },
        changeInput4(e) {
            setTimeout(()=>{
                let newString = e.target._value
                let arr = []
                for(let i = 0; i < this.hasLoginData1.length; i++){
                    if(this.hasLoginData1[i]['value'].indexOf(newString) != -1){
                        arr.push(this.hasLoginData1[i])
                    }
                }
                this.hasLoginData2 = arr
            })
        },
        sureBatchLoginOut() {
            this.batchLoginOut = false
            this.axios.post('/api/sipExtension/deleteBatch', {
                channelCodeList: this.selectedLoginedOutData,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('退出成功')
                    this.queryPathList(this.currentState)
                }else{
                    this.$message.error(response.data.message)
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        offBatchLoginOut() {
            this.batchLoginOut = false
        },
        changeInput1(e) {
            setTimeout(()=>{
                let newString = e.target._value
                let arr = []
                for(let i = 0; i < this.unLoginData1.length; i++){
                    if(this.unLoginData1[i]['value'].indexOf(newString) != -1){
                        arr.push(this.unLoginData1[i])
                    }
                }
                this.unLoginData2 = arr
            })
        },
        changeInput2(e) {
            setTimeout(()=>{
                let newString = e.target._value
                let arr = []
                for(let i = 0; i < this.loginFailedData1.length; i++){
                    if(this.loginFailedData1[i]['value'].indexOf(newString) != -1){
                        arr.push(this.loginFailedData1[i])
                    }
                }
                this.loginFailedData2 = arr
            })
        },
        changeInput3(e) {
            setTimeout(()=>{
                let newString = e.target._value
                let arr = []
                for(let i = 0; i < this.loginOfflineedData1.length; i++){
                    if(this.loginOfflineedData1[i]['value'].indexOf(newString) != -1){
                        arr.push(this.loginOfflineedData1[i])
                    }
                }
                this.loginOfflineedData2 = arr
            })
        },
        chooseOperateWay(bool) {
            this.chooseLoginIn = bool
        },
        offOperation() {
            this.batchOperation = false
        },
        nextOperation() {
            this.batchOperation = false
            if(this.chooseLoginIn){
                this.queryAllPath()
                this.batchLogin = true
                this.ifShowChoosePath = true
                this.ifShowBatchLogin = false
                this.currentChooseState = 'unlogin'
                this.loginTitle = '选择通道'
                this.selectedUnloginData = []
                this.selectedLoginFailedData = []
                this.selectedOfflineedData = []
                this.siteTip = false
                this.portTip = false
                this.registerSite = ''
                this.registerPort = ''
                this.ifUnloginChecked = false
                this.ifLoginFailedChecked = false
                this.ifOfflineedChecked = false
            }else{
                this.batchLoginOut = true
                this.selectedLoginedOutData = []
                this.queryLoginedData()
            }
        },
        chooseLoginState(params) {
            this.currentState = params
            this.queryPathList(params)
        },
        cancelPath() {
            this.pathLogin = false
        },
        cancelPayment() {
            this.pathPayment = false
        },
        surePayment() {
            this.pathPayment = false
            this.axios.delete('/api/sipExtension/'+this.channelCode)
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('退出成功')
                    this.queryPathList(this.currentState)
                }else{
                    this.$message.error(response.data.message)
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        loginIn(data) {
            this.loadingBool = false
            this.errorBool = false
            this.accoutBool = true
            this.loginData.url = ''
            this.loginData.port = ''
            this.loginData.sipCode = ''
            this.loginData.password = ''
            this.pathLogin = true
            this.loginData.channelCode = data
        },
        loginOut(data) {
            this.pathPayment = true
            this.channelCode = data
        },
        queryLoginedData() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/sipExtension/channel/list', 
                    params: {
                        status: 'LOGGED_IN'
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.hasLoginData1 = []
                    this.hasLoginData2 = []
                    let arr = response.data.data.channelList
                    for(let i = 0; i < arr.length; i++){
                        let obj = {}
                        obj.value = arr[i]['channelCode']
                        obj.label = arr[i]['channelCode']
                        this.hasLoginData1.push(obj)
                        this.hasLoginData2.push(obj)
                    }
                }else{
                    this.$message.error(response.data.message)
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryPathList(status) {
            this.axios( 
                {
                    method:'get',
                    url:'/api/sipExtension/channel/list', 
                    params: {
                        status: status
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.boxList = response.data.data.channelList
                }else{
                    this.$message.error(response.data.message)
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        sipLogin() {
            this.accoutBool = false
            this.loadingBool = true
            this.axios.post('/api/sipExtension/login', {
                channelCode: this.loginData.channelCode,
                url: this.loginData.url,
                port: this.loginData.port,
                extensionCode: this.loginData.sipCode,
                password: this.loginData.password
            })
            .then(response=> {
                this.loadingBool = false
                if(response.data.code == 0){
                    this.successBool = true
                    this.queryPathList(this.currentState)
                    setTimeout(()=>{
                        this.pathLogin = false
                        this.accoutBool = true
                        this.successBool = false
                    },2000)
                }else{
                    this.accoutBool = false
                    this.loadingBool = false
                    this.errorBool = true
                    setTimeout(()=>{
                        this.pathLogin = false
                    },2000)
                }
            })
            .catch(error=> {
                console.log(error)
                this.accoutBool = false
                this.loadingBool = false
                this.errorBool = true
                setTimeout(()=>{
                    this.pathLogin = false
                },2000)
            })
        },
        chooseBatch() {
            this.batchOperation = true
        },
        clickLoginState(state) {
            this.currentChooseState = state
        },
        offShowPath() {
            this.batchLogin = false
        },
        sortNumber(a,b){
            return a - b
        },    
        nextStep() {
            this.totalSelectedList = []
            this.totalSelectedData = []
            let arr = this.selectedUnloginData.concat(this.selectedLoginFailedData)
            let arr2 = arr.concat(this.selectedOfflineedData)
            let newArr = []
            for(let i = 0; i < arr2.length; i++){
                newArr.push(Number(arr2[i]))
            }
            let arr3 = newArr.sort(this.sortNumber);
            for(let i =0; i < arr3.length; i++){
                this.totalSelectedList.push(arr3[i]+'')
            }
            if(this.totalSelectedList.length == 0){
                this.$message.error('请先选择通道')
            }else{
                this.ifShowChoosePath = false
                this.ifShowBatchLogin = true
                this.loginTitle = '批量登录'
            }
            for(let i = 0; i < this.totalSelectedList.length; i++){
                let obj = {}
                obj.channelCode = this.totalSelectedList[i]
                obj.extensionCode = ''
                obj.password = ''
                obj.boolTip = false
                obj.disabled = false
                obj.placeholdcontent = '请输入密码'
                this.totalSelectedData.push(obj)
            }
        },
        isRepeat(arr) {
            var hash = {};
            for(var i in arr) {
                if(hash[arr[i]]) {
                    return i;
                }
                hash[arr[i]] = true;
            }
            return '';
        },
        sureSubmit() {
            if(this.registerSite.length == 0){
                this.siteTip = true
                return false
            }else{
                this.siteTip = false
            }
            if(this.registerPort.length == 0){
                this.portTip = true
                return false
            }else{
                this.portTip = false
            }
            if(this.totalSelectedData.length > 1){
                let arr = []
                for(let i = 0; i < this.totalSelectedData.length; i++){
                    this.totalSelectedData[i]['boolTip'] = false
                    if(this.totalSelectedData[i]['extensionCode']==''||this.totalSelectedData[i]['password'=='']){
                        this.$message.error('分机号和密码不能为空')
                        return false
                    }
                    arr.push(this.totalSelectedData[i]['extensionCode'])
                    if(this.ifSame){
                        this.totalSelectedData[i]['password'] = this.totalSelectedData[0]['password']
                    }
                    
                }
                let tipIndex = this.isRepeat(arr)
                if(tipIndex != ''){
                    this.totalSelectedData[tipIndex]['boolTip'] = true
                    return false
                }
            }
            let sipExtensionList = []
            for(let i = 0; i < this.totalSelectedData.length; i ++){
                let obj = {}
                obj.channelCode = this.totalSelectedData[i]['channelCode']
                obj.extensionCode = this.totalSelectedData[i]['extensionCode']
                obj.password = this.totalSelectedData[i]['password']
                sipExtensionList.push(obj)
            }
            this.batchLogin = false
            this.axios.post('/api/sipExtension/loginBatch', {
                url: this.registerSite,
                port: this.registerPort,
                sipExtensionList: sipExtensionList
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('批量执行成功')
                    this.queryPathList(this.currentState)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        changeUnloginData(e) {
            this.selectedUnloginData = e
            if(this.selectedUnloginData.length == this.unLoginData2.length){
                this.ifUnloginChecked = true
            }else{
                this.ifUnloginChecked = false
            }
        },
        changeLoginFailedData(e) {
            this.selectedLoginFailedData = e
            if(this.selectedLoginFailedData.length == this.loginFailedData2.length){
                this.ifLoginFailedChecked = true
            }else{
                this.ifLoginFailedChecked = false
            }
        },
        changeOfflineedData(e) {
            this.selectedOfflineedData = e
            if(this.selectedOfflineedData.length == this.loginOfflineedData2.length){
                this.ifOfflineedChecked = true
            }else{
                this.ifOfflineedChecked = false
            }
        },
        queryAllPath() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/sipExtension/channel/list', 
                    params: {
                        status: ''
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    let list = response.data.data.channelList
                    this.unLoginData1 = []
                    this.unLoginData2 = []
                    this.loginFailedData1 = []
                    this.loginFailedData2 = []
                    this.loginOfflineedData1 = []
                    this.loginOfflineedData2 = []
                    for(let i = 0; i < list.length; i++){
                        if(list[i]['status']=='NOT_LOGGED_IN'){
                            let obj = {}
                            obj.value = list[i]['channelCode']
                            obj.label = list[i]['channelCode']
                            this.unLoginData1.push(obj)
                            this.unLoginData2.push(obj)
                        }else if(list[i]['status']=='FAIL'){
                            let obj = {}
                            obj.value = list[i]['channelCode']
                            obj.label = list[i]['channelCode']
                            this.loginFailedData1.push(obj)
                            this.loginFailedData2.push(obj)
                        }else if(list[i]['status']=='DISCONNECT'){
                            let obj = {}
                            obj.value = list[i]['channelCode']
                            obj.label = list[i]['channelCode']
                            this.loginOfflineedData1.push(obj)
                            this.loginOfflineedData2.push(obj)
                        }
                    }
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        keepSamePassword(e) {
            if(e.target.checked){
                this.ifSame = true
                if(this.totalSelectedData.length>1){
                    for(let i = 1; i < this.totalSelectedData.length; i++){
                        this.totalSelectedData[i]['disabled'] = true
                        this.totalSelectedData[i]['placeholdcontent'] = '同上'
                        this.totalSelectedData[i]['password'] = this.totalSelectedData[0]['password']
                    }
                }
            }else{
                this.ifSame = false
                if(this.totalSelectedData.length>1){
                    for(let i = 1; i < this.totalSelectedData.length; i++){
                        this.totalSelectedData[i]['disabled'] = false
                        this.totalSelectedData[i]['placeholdcontent'] = '请输入密码'
                    }
                }
            }
        },
        deleteItem(index) {
            if(this.totalSelectedData.length == 1){
                this.$message.error('当前只有1个通道，无法删除');
            }else{
                this.totalSelectedData.splice(index,1);
            }
        },
        unloginCheckall(e) {
            this.ifUnloginChecked = e.target.checked
            if(e.target.checked) {
                this.selectedUnloginData = []
                for(let i = 0; i < this.unLoginData2.length; i++){
                    this.selectedUnloginData.push(this.unLoginData2[i]['value'])
                }
            }else{
                this.selectedUnloginData = []
            }
        },
        loginFailedCheckall(e) {
            this.ifLoginFailedChecked = e.target.checked
            if(e.target.checked) {
                this.selectedLoginFailedData = []
                for(let i = 0; i < this.loginFailedData2.length; i++){
                    this.selectedLoginFailedData.push(this.loginFailedData2[i]['value'])
                }
            }else{
                this.selectedLoginFailedData = []
            }
        },
        loginOfflinedCheckall(e) {
            this.ifOfflineedChecked = e.target.checked
            if(e.target.checked) {
                this.selectedOfflineedData = []
                for(let i = 0; i < this.loginOfflineedData2.length; i++){
                    this.selectedOfflineedData.push(this.loginOfflineedData2[i]['value'])
                }
            }else{
                this.selectedOfflineedData = []
            }
        },
        queryPic() {
            this.axios.get('/api/openApi/brand/list')
            .then(response=> {
                if(response.data.code == 0){
                    let num = parseInt(this.screenWidth/144)
                    this.picList = response.data.data
                    for(let i = 0; i < this.picList.length; i+=num){
                        this.picData.push(this.picList.slice(i,i+num))
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        jumpToLink(url) {
            if(url != ''){
                window.open(url, '_blank');
            }
        },
    },
    mounted: function() {
        this.sessionData('set','channelItem','SIP分机登录');
        this.queryPathList(this.currentState)
        this.timer = setInterval(()=>{
            this.queryPathList(this.currentState)
        },10000)
        this.screenWidth = document.body.clientWidth - 288 - 160
        this.queryPic()
        window.onresize= () => {
            return (() => {
                this.screenWidth = document.body.clientWidth - 288 - 160
                let num = parseInt(this.screenWidth/144)
                this.picData = []
                for(let i = 0; i < this.picList.length; i+=num){
                    this.picData.push(this.picList.slice(i,i+num))
                }
            })();
        }
    },
    beforeRouteLeave(to, from, next){
        next();
        clearInterval(this.timer);
    },
}
</script>
<style scoped  lang="less">
    // .slick-slide {
    //     text-align: center;
    //     height: 160px;
    //     line-height: 160px;
    //     background: #364d79;
    //     overflow: hidden;
    // }
    // .custom-slick-arrow {
    //     width: 25px;
    //     height: 25px;
    //     font-size: 25px;
    //     color: rgba(204, 204, 204, 1);
    //     background-color: rgba(31, 45, 61, 0.11);
    //     opacity: 0.3;
    // }
    // .custom-slick-arrow:hover {
    //     opacity: 1;
    //     color: rgba(204, 204, 204, 1);
    // }
    // .slick-slide h3 {
    //     color: rgba(204, 204, 204, 1);
    // }
    // .custom-slick-arrow:before {
    //     display: none;
    // }
    .channel-access{
        height: 100%;
        padding-bottom: 200px;
        .sip-content{
            height: 100%;
            padding: 24px 0 68px 24px;
            .tab{
                height: 44px;
                span{
                    display: inline-block;
                    padding-bottom: 4px;
                    color: rgba(80, 80, 80, 1);
                    margin-right: 24px;
                    cursor: pointer;
                }
                span.active{
                    color: rgba(34, 215, 187, 1);
                    border-bottom: 4px solid rgba(34, 215, 187, 1);
                }
                div{
                    display: inline-block;
                    width: 88px;
                    height: 32px;
                    background: rgba(34, 215, 187, 1);
                    color: #fff;
                    border-radius: 4px;
                    font-size: 14px;
                    float: right;
                    line-height: 32px;
                    text-align: center;
                    margin-right: 24px;
                    cursor: pointer;
                }
            }
            .list-content{
                height: 100%;
                overflow-y: auto;
                .box{
                    padding: 16px 16px 0 16px;
                    width: 208px;
                    height: 92px;
                    background: #fff;
                    display: inline-block;
                    margin-right: 18px;
                    margin-bottom: 18px;
                    position: relative;
                    img{
                        width: 28px;
                        height: 28px;
                        float: left;
                        margin-right: 8px;
                    }
                    .info{
                        display: inline-block;
                        width: 100%;
                        .info-content{
                            color:rgba(80, 80, 80, 1);
                            font-size:14px;
                            margin-left:12px;
                            cursor: pointer;
                        }
                    }
                    .new-box{
                        display: none;
                        width: 201px;
                        height: 128px;
                        border-radius: 4px;
                        position: absolute;
                        overflow: hidden;
                        left: 74px;
                        top: 43px;
                        z-index: 10;
                        color: rgba(255, 255, 255, 1);
                        font-size: 13px;
                        line-height: 20px;
                        .in-new-box{
                            position: relative;
                            width: 100%;
                            height: 100%;
                            padding: 16px 8px 16px 16px;
                            box-sizing: border-box;
                            .box-mask{
                                width: 100%;
                                height: 100%;
                                background-color: rgba(8, 11, 15, 0.7);
                                position: absolute;
                                left: 0px;
                                top: 0px;
                            }
                            div.information{
                                z-index: 12;
                                span:nth-child(1){
                                    width: 65px;
                                    color: #fff;
                                    display: inline-block;
                                }
                            }
                        }
                    }
                }
                .info-content:hover{
                    .new-box{
                        display: block;
                    }
                }
            }
        }
        .tutorials{
            height: 110px;
            padding: 0 24px;
            .brand-box{
                margin-top: 20px;
                padding: 0 24px;
                display: inline-block;
                float: left;
                img{
                    width: 120px;
                    margin-bottom: 8px;
                    height: 50px;
                    display: block;
                    // box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.1);
                }
                .carousel-pic{
                    .con{
                        float:left;
                        margin-right:24px
                    }
                    .con:nth-last-child(1){
                        margin-right: 0px;
                    }
                }
                
            }
        } 
    }
    .path-modal{
        .accout{
            div.item{
                margin-bottom: 12px;
                span{
                    display: inline-block;
                    width: 70px;
                    color: rgba(80, 80, 80, 1);
                    font-size: 14px;
                }
                input{
                    width: 310px;
                    height: 32px;
                }
            }
            div.btn-group{
                float: right;
                span{
                    width: 80px;
                    height: 32px;
                    display: inline-block;
                    border-radius: 4px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 14px;
                    cursor: pointer;
                }
                span:nth-child(1){
                    background: #fff;
                    color: rgba(34, 215, 187, 1);
                    border: 1px solid rgba(34, 215, 187, 1);
                    margin-right: 16px;
                }
                span:nth-child(2){
                    background: rgba(34, 215, 187, 1);
                    color: #fff;
                }
            }
        }
        .loading{
            text-align: center;
            div{
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
            }
            i{
                font-size: 24px;
                color: rgba(34, 215, 187, 1)
            }
        }
        .judge{
            text-align: center;
            img{
                width: 54px;
                height: 54px;
            }
            p{
                color: rgba(51, 51, 51, 1);
                font-size:16px;
            }
        }
        .path-activation{
            div.btn-group{
                float: right;
                span{
                    width: 80px;
                    height: 32px;
                    display: inline-block;
                    border-radius: 4px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 14px;
                    cursor: pointer;
                }
                span:nth-child(1){
                    background: #fff;
                    color: rgba(34, 215, 187, 1);
                    border: 1px solid rgba(34, 215, 187, 1);
                    margin-right: 16px;
                }
                span:nth-child(2){
                    background: rgba(34, 215, 187, 1);
                    color: #fff;
                }
            }
            .twice-sure{
                i{
                    color: rgba(255, 170, 0, 1);
                    font-size: 22px;
                    margin-right: 16px;
                }
                span{
                    color: rgba(80, 80, 80, 1);
                    font-size: 18px;
                }
            }
            .title{
                padding:16px 0 30px 0;
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
                padding-left: 37px;
            }
        }
    }
    .batch-loginout{
        .operate-btn{
            text-align: center;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    .batch-operation{
        .title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            margin-bottom: 16px;
        }
        .select-box{
            height: 84px;
            padding: 12px 16px 0;
            border-radius: 4px;
            border: 1px solid rgba(238, 238, 238, 1);
            margin-bottom: 16px;
            cursor: pointer;
            .box-title{
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
                margin-bottom: 6px;
            }
            .box-content{
                color: rgba(188, 188, 188, 1);
                font-size: 12px;
            }
        }
        .active{
            border: 1px solid rgba(34, 215, 187, 1);
        }
        .operate-btn{
            text-align: center;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    .choose-path{
        .modal-choose-state{
            span{
                display: inline-block;
                margin-right: 24px;
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
                cursor: pointer;
                padding-bottom: 4px;
            }
            span.active{
                color: rgba(34, 215, 187, 1);
                border-bottom: 3px solid rgba(34, 215, 187, 1);
            }
        }
        .operate-btn{
            text-align: center;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    .batch-login{
        .modal-site{
            height: 60px;
            border-bottom: 1px solid rgba(238, 238, 238, 1);
            span.title{
                width: 70px;
                display: inline-block;
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
            }
            span.tip{
                padding-left: 70px;
                color: rgba(212, 48, 48, 1);
                font-size: 12px;
            }
            input{
                width: 300px;
            }
        }
        .operate-btn{
            text-align: center;
            margin-top:12px;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
</style>
